import React from 'react';
import styles from './styles.module.scss';

type ChartSectionProps = {
  leftText: string;
  rightText: string;
  children: React.ReactNode;
};

const ChartSection: React.FC<ChartSectionProps> = ({
  leftText,
  rightText,
  children,
}) => {
  return (
    <div className={styles.chart_section}>
      <div className={styles.chart_section_header}>
        <span className={styles.left_text}>{leftText}</span>
        <span className={styles.right_text}>{rightText}</span>
      </div>
      {children}
    </div>
  );
};

export default ChartSection;
